import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { deepClone } from '@nu-art/ts-common';
import { _className, EventType_Create, EventType_Update, ModuleFE_Dialog, performAction, TS_Dialog, TS_Input } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import { ModuleFE_Reference } from '../../../../_entity.js';
export class Dialog_LoincEditor extends TS_Dialog {
    // ######################### Static #########################
    static show(onRefUpsertCallback, reference) {
        ModuleFE_Dialog.show({ content: _jsx(Dialog_LoincEditor, { onRefUpsertCallback: onRefUpsertCallback, reference: reference }), closeOverlayOnClick: () => true });
    }
    static defaultProps = {
        dialogId: 'dialog-loinc-editor',
    };
    // ######################### LifeCycle #########################
    __onReferencesUpdated = (...params) => {
        const originRef = this.state.reference;
        switch (params[0]) {
            case EventType_Create:
            case EventType_Update:
                this.props.onRefUpsertCallback(params[1], originRef);
                ModuleFE_Dialog.close();
                break;
        }
    };
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        let reference = {
            type: 'loinc',
            data: { id: '' },
        };
        if (nextProps.reference)
            reference = deepClone(nextProps.reference);
        state.reference = reference;
        return state;
    }
    // ######################### Logic #########################
    canBeSaved = () => {
        return true;
        // return !!this.state.reference.data.id;
    };
    handleSave = async () => {
        await performAction(async () => {
            this.setState({ dialogIsBusy: true });
            try {
                const ref = this.state.reference;
                await ModuleFE_Reference.v1.upsert(ref).executeSync();
            }
            catch (e) {
                this.logError(e);
            }
            finally {
                this.setState({ dialogIsBusy: false });
            }
        }, { type: 'notification', notificationLabels: 'Saving Loinc Reference' });
    };
    // ######################### Render #########################
    renderHeader = () => {
        return _jsxs(_Fragment, { children: [_jsxs("div", { className: 'header__title', children: [this.props.reference?._id ? 'Edit' : 'Add', " Loinc"] }), _jsx("div", { className: 'header__buttons', children: _jsx(ICONS.x.component, { className: "exit_icon", onClick: () => ModuleFE_Dialog.close() }) })] });
    };
    renderBody = () => {
        return _jsxs(_Fragment, { children: [_jsx("h2", { children: "Loinc ID" }), _jsx(TS_Input, { type: 'text', placeholder: 'Enter Loinc Id', value: this.state.reference.data.id, tabIndex: 0, onChange: (id) => {
                        this.state.reference.data.id = id;
                        this.forceUpdate();
                    } })] });
    };
    buttons = () => {
        return {
            right: [
                {
                    content: 'Cancel',
                    onClick: () => ModuleFE_Dialog.close(),
                },
                {
                    content: 'Save',
                    className: _className(this.canBeSaved() ? 'desired-action-button' : ''),
                    disabled: !this.canBeSaved() || this.state.dialogIsBusy,
                    onClick: this.handleSave,
                }
            ]
        };
    };
}
//# sourceMappingURL=Dialog_LoincEditor.js.map